import React from "react";


export type MenuConsultasClienteProps = {
    permitirVisualizarAtendimento: boolean
    permitirVisualizarFichaCrediario: boolean
    permitirVisualizarFichaFinanceira: boolean
    permitirVisualizarDocumentosEmAberto: boolean
    permitirVisualizarCreditos: boolean
    permitirVisualizarOrcamentoEmAberto: boolean
    permitirVisualizarLimiteDeCredito: boolean
    permitirVisualizarAcompanhamento: boolean
    permitirVisualizarUltimasCompras: boolean
    permitirVisualizarDocumentosQuitados: boolean
    permitirVisualizarCashback: boolean
    possuiCredito: boolean,
    possuiAtendimento: boolean,
    possuiAcompanhamento: boolean
    possuiCashback: boolean
    onRenderizarAtendimento: () => void
    onRenderizarFichaCrediario: () => void
    onRenderizarFichaFinanceira: () => void
    onRenderizarDocumentosEmAberto: () => void
    onRenderizarCreditos: () => void
    onRenderizarOrcamentoEmAberto: () => void
    onRenderizarLimiteDeCredito: () => void
    onRenderizarAcompanhamento: () => void
    onRenderizarUltimasCompras: () => void
    onRenderizarDocumentosQuitados: () => void
    onSelecionadoMenu: () => void;
    onRenderizarCashback: () => void
}


export const MenuConsultasCliente = (props: MenuConsultasClienteProps) => {
    return (
        <>
            <h2>Consultas</h2>

            <ul>
                {props.permitirVisualizarAtendimento && (
                    <li>
                        <a href="#"
                            style={props.possuiAtendimento ? { color: "red" } : {}}
                            onClick={() => {
                                props.onRenderizarAtendimento()
                                props.onSelecionadoMenu();
                            }}>
                            Atendimento
                        </a>
                    </li>
                )}

                {props.permitirVisualizarFichaCrediario && (

                    <li>
                        <a href="#"
                            onClick={() => {
                                props.onRenderizarFichaCrediario()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Ficha de Crediário
                        </a>
                    </li>
                )}
                {props.permitirVisualizarFichaFinanceira && (

                    <li>
                        <a href="#"
                            onClick={() => {
                                props.onRenderizarFichaFinanceira()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Ficha Financeira
                        </a>
                    </li>
                )}
                {props.permitirVisualizarDocumentosEmAberto && (

                    <li>
                        <a href="#"
                            onClick={() => {
                                props.onRenderizarDocumentosEmAberto()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Documentos em Aberto
                        </a>
                    </li>
                )}
                {props.permitirVisualizarCreditos && (

                    <li>
                        <a href="#"
                            style={props.possuiCredito ? { color: "red" } : {}}
                            onClick={() => {
                                props.onRenderizarCreditos()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Créditos
                        </a>
                    </li>
                )}
                {props.permitirVisualizarOrcamentoEmAberto && (

                    <li
                        title="Veja parâmetro: Exibir orçamentos em aberto de todas as filiais"
                    >
                        <a href="#"
                            onClick={() => {
                                props.onRenderizarOrcamentoEmAberto()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Orçamentos em Aberto
                        </a>
                    </li>
                )}
                {props.permitirVisualizarLimiteDeCredito && (

                    <li>
                        <a href="#"
                            onClick={() => {
                                props.onRenderizarLimiteDeCredito()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Limite de Crédito
                        </a>
                    </li>
                )}
                {props.permitirVisualizarAcompanhamento && (

                    <li>
                        <a href="#"
                            style={props.possuiAcompanhamento ? { color: "red" } : {}}
                            onClick={() => {
                                props.onRenderizarAcompanhamento()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Acompanhamento
                        </a>
                    </li>
                )}
                {props.permitirVisualizarUltimasCompras && (

                    <li>
                        <a href="#"
                            onClick={() => {
                                props.onRenderizarUltimasCompras()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Últimas Compras
                        </a>
                    </li>
                )}
                {props.permitirVisualizarDocumentosQuitados && (

                    <li>
                        <a href="#"
                            onClick={() => {
                                props.onRenderizarDocumentosQuitados()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Documentos Quitados
                        </a>
                    </li>
                )}
                {props.permitirVisualizarCashback && (

                    <li>
                        <a href="#"
                            style={props.possuiCashback ? { color: "red" } : {}}
                            onClick={() => {
                                props.onRenderizarCashback()
                                props.onSelecionadoMenu();
                            }}
                        >
                            Cashback
                        </a>
                    </li>
                )}
            </ul>
        </>
    )
}